import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-page-title',
  templateUrl: './page-title.component.html',
  styleUrls: ['./page-title.component.css']
})
export class PageTitleComponent implements OnInit {

  @Input() title: string;
  @Input() image: string;
  @Input() subTitle: string;
  @Input() rowID: number;
  @Input() createDate: string;

  constructor() {
  }

  ngOnInit(): void {
  }

}
